import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PatientPractitionerWithNavigationProperties } from '@models/data/patient-practitioner/PatientPractitionerWithNavigationProperties';
import { LoadingService } from '@services/helpers/loading/loading.service';
import { ModalService } from '@services/helpers/modal/modal.service';
import {CommsHttpService} from '@services/http/comms/comms-http.service';

@Injectable({
  providedIn: 'root',
})
export class ParentCommsService extends LoadingService {
  private showingDetailsSubject: BehaviorSubject<boolean>;
  public showingDetailed: Observable<boolean>;

  private activeCallSubject: BehaviorSubject<any>;
  public activeCall: Observable<any>;

  private patientSubject: BehaviorSubject<PatientPractitionerWithNavigationProperties>;
  public patient: Observable<PatientPractitionerWithNavigationProperties>;

  constructor(
    private modalService: ModalService,
  ) {
    super();
    this.patientSubject = new BehaviorSubject<PatientPractitionerWithNavigationProperties>(null);
    this.patient = this.patientSubject.asObservable();

    this.activeCallSubject = new BehaviorSubject<any>(null);
    this.activeCall = this.activeCallSubject.asObservable();

    this.showingDetailsSubject = new BehaviorSubject<any>(false);
    this.showingDetailed = this.showingDetailsSubject.asObservable();
  }

  private set patientValue(content: PatientPractitionerWithNavigationProperties) {
    this.patientSubject.next(content);
  }

  private get patientValue(): PatientPractitionerWithNavigationProperties {
    return this.patientSubject.getValue();
  }

  public hangUpCall(): void {
    // console.log('hangUpCall')
    // const callId = this.activeCallValue?.id;
    //
    // if (typeof callId !== 'undefined' && callId !== null) {
    //   const call = rainbowSDK.webRTC.getCallById(callId);
    //   if (typeof call !== 'undefined' && call !== null) {
    //     rainbowSDK.webRTC.release(callId);
    //   }
    // }
    //
    // this.resetDefaults();
    // this.modalService.closeAll();
  }

  /**
   * Resets all class attributes to their defaults
   * @private
   */
  private resetDefaults(): void {
    console.log('resetDefaults - this.activeCallValue = null;')
    this.activeCallValue = null;
    this.showingDetailsValue = false;
  }

  public answerCall(): void {
    const activeCallId = this.activeCallValue.id;
    if (this.activeCallValue.remoteMedia === 3) {
      // The remote call is of type audio + video
      // rainbowSDK.webRTC.answerInVideo(activeCallId);
    } else if (this.activeCallValue.remoteMedia === 1) {
      // The remote call is of type audio only
      // rainbowSDK.webRTC.answerInAudio(activeCallId);
    }

    this.modalService.closeModalBySlug('IncomingCallModalComponent');
  }

  /**
   * Shows the local video stream - populated by the default element selector "#minivideo"
   * @param showStreamDelay delay of showing the stream in milliseconds
   */
  public showLocalVideoStream(showStreamDelay = 500): void {
    // if (this.activeCallValue.localMedia && 2) {
    //   // bit comparison, Call.Media.VIDEO is 2
    //   setTimeout(() => {
    //     console.log('showLocalVideo');
    //     rainbowSDK.webRTC.showLocalVideo();
    //   }, showStreamDelay);
    // }
  }

  /**
   * Shows the remote video stream - populated by the default element selector "#largevideo"
   * @param showStreamDelay delay of showing the stream in milliseconds
   */
  public showRemoteVideoStream(showStreamDelay = 500): void {
    // if (this.activeCallValue?.remoteMedia && 2) {
    //   // bit comparison, Call.Media.VIDEO is 2
    //   setTimeout(() => {
    //     const activeCallId = this.activeCallValue?.id;
    //
    //     if (activeCallId !== null && typeof activeCallId !== 'undefined') {
    //       rainbowSDK.webRTC.showRemoteVideo(activeCallId);
    //     }
    //   }, showStreamDelay);
    // }
  }

  /**
   * Sets the current active call subject, if the active call is not null || undefined then it will
   * get & set the patient.
   * @param activeCall any
   */
  public set activeCallValue(activeCall: any) {
    this.activeCallSubject.next(activeCall);

    // Setting the patient value based on the new active call value
    const callIsDefined =
      typeof activeCall !== 'undefined' && activeCall !== null;

    const emailInvalid = this.activeCallValue?.contact?.loginEmail !== this.patientValue?.patientFitMedProfile?.emailAddress;
    const queryNewPatient = callIsDefined && emailInvalid;

    console.log('patientValue', this.patientValue);
    console.log('callIsDefined', callIsDefined);
    console.log('queryNewPatient', queryNewPatient);
    if (queryNewPatient) {
      this.getSetPatientFromActiveCall();
    }
  }

  public get activeCallValue(): any {
    return this.activeCallSubject.getValue();
  }

  public toggleShowingDetailed(): void {
    this.showingDetailsValue = !this.showingDetailsValue;
  }

  public toggleAudio(enabling: boolean): void {
    // const canMakeAudioVideoCall = rainbowSDK.webRTC.canMakeAudioVideoCall();
    // if (canMakeAudioVideoCall) {
    //   const activeCallId = this.activeCallValue?.id;
    //
    //   if (typeof activeCallId !== 'undefined' && activeCallId !== null) {
    //     if (enabling) {
    //       rainbowSDK.webRTC.unmuteAudioCall(activeCallId);
    //     } else {
    //       rainbowSDK.webRTC.muteAudioCall(activeCallId);
    //     }
    //   }
    // }
  }

  public toggleVideo(enabling: boolean): void {
    // const canMakeAudioVideoCall = rainbowSDK.webRTC.canMakeAudioVideoCall();
    // if (canMakeAudioVideoCall) {
    //   const activeCallId = this.activeCallValue?.id;
    //
    //   if (typeof activeCallId !== 'undefined' && activeCallId !== null) {
    //     if (enabling) {
    //       rainbowSDK.webRTC.addVideoToCall(activeCallId);
    //       this.showLocalVideoStream(1500);
    //     } else {
    //       rainbowSDK.webRTC.removeVideoFromCall(activeCallId);
    //     }
    //   }
    // }
  }

  private get showingDetailsValue(): boolean {
    return this.showingDetailsSubject.getValue();
  }

  private set showingDetailsValue(content: boolean) {
    this.showingDetailsSubject.next(content);
  }

  private getSetPatientFromActiveCall(): void {
    // this.loading = true;
    //
    // const commsId = this.activeCallValue.contact.dbId
    //
    // this.commsHttpService
    //   .fitMedProfileFromCommsId(commsId)
    //   .pipe(take(1))
    //   .subscribe({
    //     next: (response) => {
    //       this.patientValue = {patientFitMedProfile: response.body};
    //
    //       this.patientPractitionerService
    //         .getFromPatientFmpId(this.patientValue?.patientFitMedProfile?.id)
    //         .then((pp) => {
    //           this.patientValue = pp;
    //           this.loading = false;
    //         })
    //     },
    //     error: (_) => this.loading = false
    //   })
  }
}
